import React, { useEffect, useState } from 'react';
import { AlertTriangle, Info, Wrench, X } from 'lucide-react';
import apiClient from '@/utils/api';

const SEVERITY_CONFIG = {
  info: { bg: 'bg-blue-600', icon: Info, text: 'text-white' },
  warning: { bg: 'bg-amber-500', icon: AlertTriangle, text: 'text-white' },
  maintenance: { bg: 'bg-red-600', icon: Wrench, text: 'text-white' },
};

const MaintenanceBanner = () => {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    apiClient.get('/config/maintenance-banner')
      .then(res => {
        if (res.data?.enabled && res.data?.message) setBanner(res.data);
      })
      .catch((err) => {
        console.warn('Maintenance banner fetch failed:', err?.message || err);
        setBanner({ enabled: false, message: '' });
      });
  }, []);

  if (!banner || dismissed) return null;

  const config = SEVERITY_CONFIG[banner.severity] || SEVERITY_CONFIG.info;
  const Icon = config.icon;

  return (
    <div className={`${config.bg} ${config.text} px-4 py-2.5 relative z-[60]`} data-testid="maintenance-banner">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3">
        <Icon className="w-4 h-4 flex-shrink-0" />
        <p className="text-sm font-medium" data-testid="maintenance-banner-message">{banner.message}</p>
        <button
          onClick={() => setDismissed(true)}
          className="absolute right-4 top-1/2 -translate-y-1/2 opacity-70 hover:opacity-100 transition-opacity"
          data-testid="maintenance-banner-dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default MaintenanceBanner;
